// Disabled Help Center routes (Community Edition doesn’t use this)
export default {
  routes: [],
};

